import { FC, useEffect, useState } from 'react';
import { getFileBaseUrl } from '@/api/files/api';
import { Attachment } from '@/library/types/files';
import { getDocumentPreviewSrc } from '../helpers';

type DocumentProps = {
  fileType: string;
  file: Attachment;
};

const Document: FC<DocumentProps> = ({ fileType, file }) => {
  const [hasError, setHasError] = useState(false);
  const [isFrameLoaded, setIsFrameLoaded] = useState(false);
  const [index, setIndex] = useState(0);
  const forceRerenderTimes = 0;

  const previewImageBaseUrl = getFileBaseUrl();

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (!isFrameLoaded) {
      timer = setTimeout(() => {
        // If iframe is not loaded & index is 0, increase index to force iframe to rerender.
        if (index <= forceRerenderTimes) {
          setIndex(old => old + 1);
        } else {
          // If iframe is not loaded & index is 1 then show the error message.
          setHasError(true);
        }
      }, 2500);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [file.url_inline, file.url_encoded, index, isFrameLoaded]);

  const onLoadHandler = () => {
    setIsFrameLoaded(true);
    setHasError(false);
  };

  const previewSrc = getDocumentPreviewSrc(fileType, file, previewImageBaseUrl);
  const cannotPreview = !previewSrc;

  return (
    <>
      {hasError || cannotPreview ? (
        <div className="text-dark fs-12 position-absolute top-50 start-0 w-100p text-center">
          Preview Unavailable
        </div>
      ) : null}

      {cannotPreview ? null : (
        <iframe
          key={index}
          title={file.filename}
          src={previewSrc}
          width="100%"
          height="100%"
          onLoad={onLoadHandler}
          onError={() => setHasError(true)}
          frameBorder="0"
        ></iframe>
      )}
    </>
  );
};

export default Document;
